module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid32_1060x866.d0b53ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid32_1060x866.jpg
// module id = j94f
// module chunks = 0